import React, { useState } from "react";
import AsyncSelect from "react-select/async";

const SearchSelect = (props) => {
  const [input, setInput] = useState("");

  const handleNoOptionsMessage = () => {
    return input ? "No options" : "Please search an item";
  };

  let colClass = props.class ? props.class : "form-group";
  let labelClass = props.classLabel ? props.classLabel : "col-2 col-form-label mr-1";
  let inputClass = props.classInput ? props.classInput : "col";
  return (
    <div className={`${colClass + (props.error ? "has-danger" : "")}`}>
      {props.label && (
        <label className={labelClass} htmlFor="select">
          {props.label}
        </label>
      )}
      <div className={inputClass}>
        <AsyncSelect
          name="form-field-name"
          matchProp="label"
          loadOptions={props.getOptions}
          isLoading={props.isLoading}
          onChange={props.onChange}
          value={props.value}
          placeholder="Search Item"
          noOptionsMessage={handleNoOptionsMessage}
          onInputChange={setInput}
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              neutral20: "#e9ebec",
            },
          })}
          className={props.error ? "form-control form-control-danger" : ""}
        />
      </div>
      {props.error ? (
        <em id="firstname-error" className="error form-control-feedback">
          Please select Item
        </em>
      ) : (
        <em></em>
      )}
    </div>
  );
};

export default SearchSelect;
